var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 240,
    viewBox: "0 0 350 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6314 160.7L36.6213 160.704L47.2224 188.768L47.2326 188.764L47.2795 188.888L238.757 116.559L241.537 123.919L234.053 126.746L50.0494 196.252L42.5656 199.079L39.7386 191.595L29.1374 163.531L26.3104 156.047L33.7943 153.22L217.798 83.7137L225.282 80.8867L228.08 88.2934L36.6023 160.623L36.6314 160.7Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.03 50.3813L269.456 63.7315L285.672 107.614L319.884 94.4039L322.854 101.832L288.445 115.118L280.982 118L278.209 110.496L261.993 66.6132L259.22 59.1092L266.683 56.2275L301.06 42.9531L304.03 50.3813Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.008 87.8563C229.003 87.5715 229 87.2861 229 87C229 62.6995 248.699 43 273 43C281.289 43 289.043 45.2922 295.662 49.2773L294.467 46.1126L301.458 43.4715C293.282 38.1149 283.505 35 273 35C244.281 35 221 58.2812 221 87C221 88.2878 221.047 89.5646 221.139 90.8289L229.008 87.8563ZM239.958 116.057C248.022 125.219 259.836 131 273 131C292.655 131 309.3 118.112 314.946 100.326L316.373 104.105L322.912 101.635C316.591 123.229 296.637 139 273 139C256.37 139 241.564 131.194 232.045 119.046L239.958 116.057Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpanner);
export default __webpack_public_path__ + "static/media/spanner.d37666e796f899415c93625eeeb9f803.svg";
export { ForwardRef as ReactComponent };